import {
  Grid,
} from "@material-ui/core";
import { Sidebar } from "../Sidebar";
import SiteTable from "./SiteTable";

export const SitePage = () => {
  return (
    <>
      <div style={{ marginTop: 80, display: 'flex' }}>
        <Sidebar />
        <Grid container direction="column" spacing={1}>
          <Grid item>
            <SiteTable />
          </Grid>
        </Grid>
      </div>
    </>
  );
};
